'use client'

import { useEffect } from 'react'

// Extend globalThis to include dataLayer (mirrors Window declaration in GTMScript)
declare global {
  // eslint-disable-next-line no-var
  var dataLayer: unknown[]
}

export interface GTMDataLayerProps {
  /**
   * Environment (local, stg, prod).
   */
  env: string
  /**
   * App version.
   */
  version: string
  /**
   * Service name.
   */
  service: string
}

/**
 * GTMDataLayer component that pushes configuration to the dataLayer.
 * This makes env, version, and service available to GTM tags (e.g., Datadog RUM).
 */
export const GTMDataLayer: React.FC<GTMDataLayerProps> = ({
  env,
  version,
  service,
}) => {
  useEffect(() => {
    globalThis.dataLayer ??= []
    globalThis.dataLayer.push({
      ddEnv: env,
      ddVersion: version,
      ddService: service,
    })
  }, [env, version, service])

  return null
}
